// import nativeFunctions from 'mobile-bridge/functions';
import { useEffect, useMemo, useState } from 'react';
// import { TB_SETTING, useIndexedDB } from './useIndexedDB';
import { KEY_ENABLE_CURRENT_LOCATION, KEY_ENABLE_INTERESTED_LOCATIONS } from 'data/constants';

// const LocationSettingId = 'location';
// const TYPE_GPS = 'gps';
// const TYPE_BOOKMARK = 'bookmark';

export function useSettings() {
  // const { getById, checkExists, addRow, updateRow } = useIndexedDB(TB_SETTING);
  // const [isGPS, setIsGPS] = useState();
  // const [isBookmark, setIsBookmark] = useState();

  const [enableCurrentLocation, setEnableCurrentLocation] = useState(localStorage.getItem(KEY_ENABLE_CURRENT_LOCATION) === 'true');
  const [enableInterestedLocations, setEnableInterestedLocations] = useState(localStorage.getItem(KEY_ENABLE_INTERESTED_LOCATIONS) === 'true');

  // const getLocationSetting = async () => {
  //   const result = await getById(LocationSettingId);
  //   if (result) {
  //     switch (result.value) {
  //       case TYPE_GPS:
  //         nativeFunctions.getLocTermConfig();
  //         break;
  //       case TYPE_BOOKMARK:
  //         setIsBookmark(true);
  //         setIsGPS(false);
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     setIsGPS(false);
  //     setIsBookmark(false);
  //   }
  // };

  // /**
  //  * Set location setting with gps or bookmark value
  //  * @param {'gps' | 'bookmark' | null} value
  //  */
  // const setLocationSetting = async (value) => {
  //   const isExist = await checkExists(LocationSettingId);
  //   if (isExist) {
  //     await updateRow({ type: LocationSettingId, value });
  //   } else {
  //     await addRow({ type: LocationSettingId, value });
  //   }

  //   getLocationSetting();
  // };

  useEffect(() => {
    const savedEnableCurrentLocation = localStorage.getItem(KEY_ENABLE_CURRENT_LOCATION);
    const savedEnableInterestedLocation = localStorage.getItem(KEY_ENABLE_INTERESTED_LOCATIONS);

    setEnableCurrentLocation(savedEnableCurrentLocation === 'true');
    setEnableInterestedLocations(savedEnableInterestedLocation === 'true');
  }, []);

  // useEffect(() => {
  //   const handleLocTermConfigEvent = (e) => {
  //     const { allowed } = e.detail || {};
  //     if (allowed) {
  //       setIsGPS(true);
  //       setIsBookmark(false);
  //     }
  //   };

  //   window.addEventListener('getLocTermConfig', handleLocTermConfigEvent);
  //   return () => window.removeEventListener('getLocTermConfig', handleLocTermConfigEvent);
  // }, []);

  return useMemo(
    () => ({
      enableCurrentLocation,
      enableInterestedLocations,
      setEnableCurrentLocation,
      setEnableInterestedLocations
    }),
    [enableCurrentLocation, enableInterestedLocations, setEnableCurrentLocation, setEnableInterestedLocations],
  );
}

export default useSettings;
